import React, {useState} from 'react';
import {Modal, DatePicker} from 'antd';
import dayjs from 'dayjs';

const {RangePicker} = DatePicker;

const DateTimeModal = ({
                           isDateTimeModalVisible,
                           setIsDateTimeModalVisible,
                           setCustomDateRange,
                           handleDateTimeSubmit,
                       }) => {
    const [selectedRange, setSelectedRange] = useState([null, null]);
    const [fromDate, setFromDate] = useState(null);

    const handleDateChange = (dates) => {
        if (dates && dates[0] && dates[1]) {
            const diffSeconds = dates[1].diff(dates[0], 'second');
            const secondsIn24Hours = 24 * 60 * 60;

            if (diffSeconds > secondsIn24Hours) {
                const adjustedEndDate = dates[0].add(24, 'hour');
                setSelectedRange([dates[0], adjustedEndDate]);
                setCustomDateRange([dates[0], adjustedEndDate]);
            } else {
                setSelectedRange(dates);
                setCustomDateRange(dates);
            }
        } else {
            setSelectedRange(dates);
            setCustomDateRange(dates);
        }
    };

    const handleCalendarChange = (dates) => {
        if (dates && dates[0]) {
            setFromDate(dates[0]);
        } else {
            setFromDate(null);
        }
    };

    const disabledDateTime = (current, type) => {
        if (!current || !fromDate) return {};

        if (type === 'end') {
            const maxDateTime = fromDate.add(24, 'hour');
            const currentTime = current;

            const disabledHours = [];
            const disabledMinutes = [];
            const disabledSeconds = [];

            // Saat kontrolü
            for (let i = 0; i < 24; i++) {
                if (currentTime.clone().hour(i).isAfter(maxDateTime)) {
                    disabledHours.push(i);
                }
            }

            // Dakika kontrolü - eğer son saatteyse
            if (currentTime.hour() === maxDateTime.hour()) {
                for (let i = 0; i < 60; i++) {
                    if (i > maxDateTime.minute()) {
                        disabledMinutes.push(i);
                    }
                }
            }

            // Saniye kontrolü - eğer son saat ve dakikadaysa
            if (currentTime.hour() === maxDateTime.hour() &&
                currentTime.minute() === maxDateTime.minute()) {
                for (let i = 0; i < 60; i++) {
                    if (i > maxDateTime.second()) {
                        disabledSeconds.push(i);
                    }
                }
            }

            return {
                disabledHours: () => disabledHours,
                disabledMinutes: () => disabledMinutes,
                disabledSeconds: () => disabledSeconds,
            };
        }

        return {};
    };

    const disabledDate = (current) => {
        if (!current) return false;

        if (!fromDate) {
            // Başlangıç tarihi seçilmemişse sadece bugünden sonraki tarihleri disable et
            const today = dayjs();
            return current.isAfter(today, 'day');
        }

        // Başlangıç tarihi seçilmişse, 24 saatten fazla olan tarihleri disable et
        const maxDateTime = fromDate.add(24, 'hour');
        return current.isAfter(maxDateTime, 'day');
    };

    const handleOk = () => {
        handleDateTimeSubmit(selectedRange);
        setIsDateTimeModalVisible(false);
    };

    return (
        <Modal
            title="Tarih ve Saat Seç"
            open={isDateTimeModalVisible}
            onOk={handleOk}
            onCancel={() => setIsDateTimeModalVisible(false)}
        >
            <RangePicker
                showTime={{
                    format: 'HH:mm:ss',
                    hideDisabledOptions: true,
                }}
                format="YYYY-MM-DD HH:mm:ss"
                disabledDate={disabledDate}
                disabledTime={disabledDateTime}
                style={{width: '100%'}}
                onChange={handleDateChange}
                onCalendarChange={handleCalendarChange}
                placeholder={['Başlangıç Tarihi', 'Bitiş Tarihi']}
                value={selectedRange}
            />
        </Modal>
    );
};

export default DateTimeModal;